import {GetStatesListService} from '../../../../http-services/rdu-loc/ib-get-states-list-service';
import {GetCommunityListByCountryService} from '../../../../http-services/rdu-loc/ib-get-communities-list-service';
import {ibUiCommunityListByCountryTransformer} from '../transformer/ib-ui-community-list-by-country-transformer';

@Service('ib-ui-community-list-by-country-module', [
    '$q',
    'GetStatesListService',
    'GetCommunityListByCountryService',
    'ibUiCommunityListByCountryTransformer'
])
export class ibUiCommunityListByCountryService {
    public defer = this.$q.defer();
    public executeFormAction:Function;
    private singleInit:boolean;
    constructor (
        private $q: ng.IQService,
        private GetStatesListService: GetStatesListService,
        private GetCommunityListByCountryService: GetCommunityListByCountryService,
        private ibUiCommunityListByCountryTransformer: ibUiCommunityListByCountryTransformer
    ) {
        this.singleInit = false;
    }

    initializeCommunityListByCountry = (statesLiteral:string, country?:string, promise?: any): angular.IPromise<any> => {
        this.defer = this.$q.defer();

        const initializeCommunityListByCountryError = (error): void => {
            this.defer.reject(error);
        };

        const initializeCommunityListByCountrySuccess = (states): void => {
            this.defer.resolve(states);
        };
        const initializeStateListByCountrySuccess = (states): void => {
            this.defer.resolve(this.ibUiCommunityListByCountryTransformer.transformStateList(states));
        };

        switch (statesLiteral) {
                case 'PROVINCE_FIELD':
                    this.GetCommunityListByCountryService.getCommunityListByCountry('ES').then(initializeCommunityListByCountrySuccess, initializeCommunityListByCountryError);
                    break;
                case 'STATE_FIELD':
                    this.GetStatesListService.getStatesList(country).then(initializeStateListByCountrySuccess, initializeCommunityListByCountryError);
                    break;
                default: this.defer.resolve([]);
        }

        return this.defer.promise;
    };

    /**
     * @param executeFormAction Execute Action on a from
     */
    public setFormInterfaces (executeFormAction:Function) {
        if (!this.singleInit) {
            this.executeFormAction = executeFormAction;
            this.singleInit = true;
        }
    }

}